import { varsFromServer } from 'client/javascript/client_side_injection_vars';

function getLocaleModuleName() {
  const { locale } = varsFromServer;

  switch (locale) {
    case [
      'de-DE',
      'fr-CA',
      'ms-MY',
      'sv-SE',
      'fr-FR',
      'th-TH',
      'ar-AE',
      'he-IL',
      'nl-NL',
      'vi-VN',
      'id-ID',
      'pl-PL',
      'zh-CN',
      'es-ES',
      'it-IT',
      'pt-BR',
      'zh-TW',
      'cs-CZ',
      'es-LA',
      'ja-JP',
      'pt-PT',
      'da-DK',
      'fi-FI',
      'ko-KR',
      'ru-RU'
    ].find(l => l === locale):
      return locale.substr(0, locale.indexOf('-'));

    case 'ca-ES':
      return 'cat';

    case 'nb-NO':
      return 'no';

    case 'en-US':
    case 'en-GB':
    case 'en-ZA':
    default:
      return 'default';
  }
}

export async function getDatePickerLocale() {
  const moduleName = getLocaleModuleName();
  const module = await import(/* webpackChunkName: "flatpickr-l10n" */ `flatpickr/dist/l10n/${moduleName}.js`);

  return moduleName === 'default' ? module.english : module.default[moduleName];
}
